import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './NavigationHeading.css'
import translation from '@healthwise-ui/core/Translation'
import { PrinterIcon } from '@healthwise-ui/core/Icon'
import DropDown from '@healthwise-ui/core/DropDown'
import FeatureFlipper from '@healthwise-ui/core/FeatureFlipper'

class NavigationHeading extends Component {
  render () {
    const printItems = [
      {name: 'Small', value: '12pt', component: (<span style={{'fontSize': '1em'}}>Small</span>)},
      {name: 'Medium', value: '14pt', component: (<span style={{'fontSize': '1.25em'}}>Medium</span>)},
      {name: 'Large', value: '16pt', component: (<span style={{'fontSize': '1.75em'}}>Large</span>)}
    ]
    return (
      <nav className={styles.nav}>
        <div className={styles.banner}>
          <div className={styles.bannerInner}>
            <h1 className={styles.bannerText}>{translation(this.props.localization, 'DecisionAid')}</h1>
            <FeatureFlipper
              evaluate={(document.getElementById('hw-hide-esdp-print-drop-down') || { value: 'false' }).value !== 'true'}
              data-instructions="Keep in place until 11.2 is no longer available in production">
              <DropDown
                items={printItems}
                prompt={'Print'}
                maintainPrompt
                onSelect={this.props.onSelection}
                icon={PrinterIcon({role: 'presentation', className: 'hw-icon-white'})}
              />
            </FeatureFlipper>
          </div>
        </div>
        {this.props.children}
      </nav>
    )
  }
}

NavigationHeading.propTypes = {
  children: PropTypes.node,
  localization: PropTypes.string,
  onSelection: PropTypes.func.isRequired
}

NavigationHeading.defaultProps = {
  localization: 'en-us',
  onSelection: function (value, event) {
    console.error('No onSelection function provided. ' + value, event)
  }
}

export default NavigationHeading



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/NavigationHeading/index.js